<template>
    <div class="add-new-main-dialog">
        <el-dialog :visible="visible" title="客户信息变更" width="1230px" :close-on-click-modal='false'
            :close-on-press-escape='false' @close="handleClose">
            <div class="add-main-form-box">
                <table-box class="add-main-dialog-table" v-loading="subTabTable.tableLoading" ref="tableBox"
                    :selection="false" :height="config.height" :columns="config.columns" :rows="subTabTable.totalData"
                    :highlight-current-row="true" :selectable="config.selectable">
                </table-box>
            </div>

        </el-dialog>
    </div>
</template>

<script>
import { ref, reactive } from '@vue/composition-api';
import tableBox from '@/components/lots/tableBox/Index';
import { ListClass } from '@/modules/mdm/composition/dc/common/list/ListClass';
import { tableConfig } from './config.js';
import { getCustomerComparsionPage } from '@/modules/mdm/api/customer/customerManage.js';
export default {
    components: { tableBox },
    props: {},
    /* eslint-disable max-lines-per-function */
    setup(props, setupContext) {
        const config = reactive(tableConfig);
        const emit = setupContext.emit;
        class DataDetailClass extends ListClass {
            beforeGetList(condition) {
                return condition;
            };
            afterGetList(res) {
                if (+res.code === 0) {
                    subTabTable.totalData.value = res.data || [];
                }
            }
        };

        const subTabTable = new DataDetailClass({
            Api: {
                listApi: getCustomerComparsionPage
            }
        });

        const visible = ref(false);
        const show = (val) => {
            visible.value = true;
            subTabTable.getList({
                customerChangeCode: val
            });
        };
        const handleClose = () => {
            visible.value = false;
        };
        return {
            emit,
            config,
            subTabTable,
            visible,
            show,
            handleClose
        };
    }
};
</script>
<style lang="less">
.add-new-main-dialog {
    .add-main-form-box {
        width: 100%;
        padding: 0 20px;
        box-sizing: border-box;

        .el-select {
            width: 100%;
        }
    }

    .add-main-dialog-table {
        margin: 10px 0 5px 0;
    }
}
</style>
